var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HouseLine"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7482 16.25H17.4982V9.02648C17.498 8.85234 17.4615 8.68016 17.3911 8.52091C17.3207 8.36166 17.2178 8.21884 17.0891 8.10157L10.8385 2.41913C10.609 2.20889 10.309 2.09229 9.99766 2.0923C9.68636 2.09231 9.38636 2.20895 9.1568 2.41921L2.90726 8.10157C2.77853 8.21883 2.67566 8.36165 2.60523 8.52089C2.53479 8.68014 2.49833 8.85233 2.49817 9.02646V16.25H1.24817C1.08241 16.25 0.923437 16.3159 0.806227 16.4331C0.689017 16.5503 0.623169 16.7092 0.623169 16.875C0.623169 17.0408 0.689017 17.1997 0.806227 17.3169C0.923437 17.4342 1.08241 17.5 1.24817 17.5H18.7482C18.9139 17.5 19.0729 17.4342 19.1901 17.3169C19.3073 17.1997 19.3732 17.0408 19.3732 16.875C19.3732 16.7092 19.3073 16.5503 19.1901 16.4331C19.0729 16.3159 18.9139 16.25 18.7482 16.25ZM8.12454 11.25H11.8745V16.25H8.12454V11.25Z",
    fill: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseLine);
export default __webpack_public_path__ + "static/media/house-line.f82412bbe3befb60f54a9ed59848df36.svg";
export { ForwardRef as ReactComponent };